import reactGA from 'react-ga4';

const Spy = (Categoria, Accion, Etiqueta = '') => {
  reactGA.event({
    category: Categoria,
    action: Accion,
    label: Etiqueta, // Added this for more detail
  });
};

export default Spy;
